import React from 'react';
import { motion } from 'framer-motion';

import Button from '../../shared/components/FormElements/Button/Button';
import Evaluation from './Evaluation';
import './InterviewList.css';

const EvaluationList = props => {
    if (props.items.length === 0) {
      return (
        <div className="interview-list center">
            <h3>No evaluation is made yet. </h3>
        </div>
      );
    }
  
    return (
    <div className='interview-div'>
      <ul className="interview-list">
        {props.items.map((evaluation, index) => (
          <Evaluation
            key={evaluation._id}
            id={evaluation._id}
            dateCreated={evaluation.dateCreated}
            index={index}
          />
        ))}
      </ul>
    </div>
    );
  };
  
  export default EvaluationList;